import React from 'react';

import { Label } from 'rbx';
import BasicTextEditor from './BasicTextEditor';

const CancellationTerms = ({ values, setFieldValue, errors, touched }) => (
  <div className="m-4">
    <div>
      <Label className="is-flex is-justify-content-left is-align-items-center">
        Cancellation Terms: Terms & Conditions{' '}
        <a
          onClick={() => {
            setFieldValue(
              'cancellation_terms_and_condition',
              values.default_cancellation_terms_and_condition,
            );
          }}
          className="button is-grey ml-2"
        >
          <span className="has-text-weight-semibold">
            Restore to default terms and conditions
          </span>
        </a>
      </Label>
    </div>
    <BasicTextEditor
      disabled={!values.cancel_booking}
      name="booking_message"
      value={values.cancellation_terms_and_condition}
      handleChange={e => setFieldValue('cancellation_terms_and_condition', e)}
      // onBlur={handleBlur}
      errors={errors.cancellation_terms_and_condition}
      touched={touched.cancellation_terms_and_condition}
      disableToastMessage
      optionalText="(Min 10 and Max 1000 characters)"
    />
    {values.cancellation_terms_and_condition && (
      <div style={{ textAlign: 'right' }}>
        {values.cancellation_terms_and_condition.length > 1000 ||
        values.cancellation_terms_and_condition.length < 10
          ? ''
          : `Characters left ${1000 -
              values.cancellation_terms_and_condition.length}`}
      </div>
    )}
  </div>
);

export default CancellationTerms;
